export var MULTILINGUAL_NAMESPACE = 'multilingual';
export function getLocaleNamespace(locale) {
    return MULTILINGUAL_NAMESPACE + "_" + locale;
}
//# sourceMappingURL=getLocaleNamespace.js.map